import { styled } from '@linaria/react';

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
`;

export const ContentContainer = styled.div`
    max-height: calc(100vh - 150px);
    overflow-y: auto;
    font-size: 0.8rem;
`;

export const HeaderSection = styled.div`
    margin-bottom: 1rem;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    overflow: hidden;
`;

export const HeaderTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem 1rem;
    background: #f8f9fa;
    border-bottom: 1px solid #e0e0e0;
`;

export const ItemName = styled.div`
    display: flex;
    align-items: baseline;
    gap: 0.5rem;
    font-size: 1rem;
    font-weight: 600;
    color: #333;

    span.item-id {
        font-size: 0.75rem;
        font-weight: 400;
        color: #888;
    }
`;

export const BadgeRow = styled.div`
    display: flex;
    gap: 0.5rem;
    align-items: center;
`;

export const Badge = styled.span<{ variant: 'type' | 'pending' | 'reviewed' | 'category' }>`
    display: inline-flex;
    align-items: center;
    padding: 0.2rem 0.6rem;
    border-radius: 3px;
    font-size: 0.7rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    background: ${(props) =>
        props.variant === 'type'
            ? '#e8eaf6'
            : props.variant === 'pending'
              ? '#e65100'
              : props.variant === 'reviewed'
                ? '#2e7d32'
                : props.variant === 'category'
                  ? 'transparent'
                  : '#eee'};
    color: ${(props) =>
        props.variant === 'type'
            ? '#3949ab'
            : props.variant === 'pending'
              ? '#fff'
              : props.variant === 'reviewed'
                ? '#fff'
                : props.variant === 'category'
                  ? '#333'
                  : '#666'};
`;

export const HeaderDetails = styled.div`
    display: flex;
`;

export const DetailGroup = styled.div<{ variant?: 'reviewed' | 'pending' }>`
    flex: 1;
    padding: 0.75rem 1rem;
    background: ${(props) =>
        props.variant === 'reviewed'
            ? '#f0faf0'
            : props.variant === 'pending'
              ? '#fff8f0'
              : '#fff'};
    border-left: ${(props) =>
        props.variant === 'reviewed'
            ? '3px solid #2e7d32'
            : props.variant === 'pending'
              ? '3px solid #e65100'
              : 'none'};

    &:not(:last-child) {
        border-right: 1px solid #e0e0e0;
    }
`;

export const DetailGroupLabel = styled.div`
    font-size: 0.65rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #999;
    margin-bottom: 0.4rem;
`;

export const DetailGroupValue = styled.span`
    font-size: 0.75rem;
    color: #333;
`;

export const Column = styled.div`
    flex: 1;
`;

export const FieldRow = styled.div`
    margin-bottom: 0.25rem;
    display: flex;
    align-items: baseline;
`;

export const FieldLabel = styled.label`
    display: inline-block;
    width: 80px;
    font-weight: 600;
    font-size: 0.75rem;
    color: #666;
`;

export const FieldValue = styled.span`
    color: #333;
`;

export const UserAvatarSmall = styled.div`
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: rgb(0, 68, 126);
    color: rgb(255, 255, 255);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    font-weight: 700;
    flex-shrink: 0;
    letter-spacing: 0.3px;
`;

export const UserFieldCell = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const ChangesSection = styled.div`
    margin-top: 1rem;
`;

export const SectionHeader = styled.h3<{ color?: string; marginLeft?: string }>`
    color: ${(props) => props.color || '#333'};
    margin: 1rem;
    font-size: 1.2rem;
    ${(props) => props.marginLeft && `margin-left: ${props.marginLeft};`}
`;

export const SectionContainer = styled.div<{ withPadding?: boolean }>`
    margin-bottom: 1.5rem;
    ${(props) => props.withPadding && 'padding: 0 1rem;'}
`;

export const ChangeItem = styled.div`
    margin-bottom: 0.25rem;
`;

export const ChangeBox = styled.div<{ variant: 'removed' | 'added' }>`
    background-color: ${(props) => (props.variant === 'removed' ? '#f2dede' : '#dff0d8')};
    padding: 0.5rem 1rem;
    border-left: 3px solid ${(props) => (props.variant === 'removed' ? '#d9534f' : '#5cb85c')};
`;

export const ChangeBoxContent = styled.div`
    color: #333;
`;

export const BoldText = styled.span`
    font-weight: bold;
`;

export const ColoredLabel = styled.span<{ color: string }>`
    color: ${(props) => props.color};
    font-weight: bold;
`;

export const ChangedFieldContainer = styled.div`
    display: flex;
    gap: 0.5rem;
`;

export const ChangedFieldBox = styled.div<{ variant: 'removed' | 'added' }>`
    flex: 1;
    background-color: ${(props) => (props.variant === 'removed' ? '#f2dede' : '#dff0d8')};
    padding: 0.5rem 1rem;
    border-left: 3px solid ${(props) => (props.variant === 'removed' ? '#d9534f' : '#5cb85c')};
`;

export const ValueList = styled.ul`
    margin: 0.5rem 0;
    padding-left: 1.5rem;
`;

export const ArrayGrid = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    margin: 0.5rem 0;
`;

export const ArrayCard = styled.div`
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 0.5rem 0.75rem;
    background: rgba(255, 255, 255, 0.5);
    min-width: 180px;
    max-width: 320px;
`;

export const SuccessMessage = styled.div`
    padding: 1rem;
    background-color: #dff0d8;
    color: #3c763d;
    margin-top: 1rem;
`;

export const ErrorMessage = styled.div`
    padding: 1rem;
    background-color: #f2dede;
    color: #a94442;
    margin-top: 1rem;
`;
